import generateContext, { createAction } from '@shared/context';
import { stringToNumberFrom0To9 } from '@shared/utils';
interface ICouriersState {
  selectedCourierId: any;
  totalGuestCourier: number;
  couriersById: Dictionary<ICourier>;
  couriersList:Array<ICourier>
}
interface IOrder {
  uuid: string;
  reference: string;
}

export interface ICourierDeleted {
  id: string;
  timestamp: number;
}

export enum CourierReturnStatusType {
  Returning = 'RETURNING',
  Nearby = 'NEARBY',
  Arrived = 'ARRIVED'
}

export enum CourierViewType {
  ListView = 'LISTVIEW',
  ActionView = 'ACTIONVIEW',
}

interface IEta {
  eta: string;
  id: string;
  timestamp: number;
}
export interface ICourierReturnStatus {
  timestamp: number;
  id: string;
  status: CourierReturnStatusType;
}

export interface IWaypoint {
  order: IOrder;
  isDelivered: boolean;
  location: Coordinates;
  lastUpdatedAt: any;
}

export interface IRoute {
  timestamp: number;
  id: string;
  courier: {
    id: string;
    vehicleType?: CourierVehicleType;
  };
  waypoints: IWaypoint[];
}


export interface ICourier {
  id: string;
  firstName: string;
  lastName: string;
  vehicleType?: CourierVehicleType;
  location?: Coordinates;
  timestamp?: number;
  lastLocationUpdated?: number;
  lastPoolUpdated?: number;
  accentColor?: string;
  returnBack?: ICourierReturnStatus | null;
  isGuest?: boolean;
  backBy?: IEta | null;
  orderPool?: {
    nextOrderReference: string | null;
    orderBeingDelivered: number;
    totalOrders: number;
    route: IRoute;
  };
  nextOrderPool?: {
    route: IRoute
  };
  guestQueueNumber?: number;
  isCourierInDelivery?: boolean;
}

export enum CourierVehicleType {
  Bike = 'BIKE',
  EBike = 'EBIKE',
  Scooter = 'SCOOTER',
  Car = 'CAR',
}

enum CouriersActionType {
  AddCourier = 'ADD_COURIER',
  UpdateCourier = 'UPDATE_COURIER',
  SetSelectedCourierId = 'SET_SELECTED_COURIER',
  UpdateCourierLocation = 'UPDATE_COURIER_LOCATION',
  UpdateCourierRoute = 'UPDATE_COURIER_ROUTE',
  SetCouriers = 'SET_COURIERS',
  SetCourierRoutes = 'SET_COURIER_ROUTES',
  SetCourierStatus = 'SET_COURIER_STATUS',
  UpdateCourierStatus = 'UPDATE_COURIER_STATUS',
  SetEtaLists = 'SET_ETA_LIST_SNAPSHOT',
  UpdateEta = 'UPDATE_ETA',
  CourierDeleted = 'COURIER_DELETED',
  NextRouteUpdate = 'NEXT_ROUTE_UPDATE',
  SetNextRoute = 'SET_NEXT_ROUTE',
  SetCourierInDelivery = 'SET_COURIER_IN_DELIVERY'

}

const initialState: ICouriersState = {
  selectedCourierId: null,
  totalGuestCourier: 0,
  couriersById: {},
  couriersList: []
};

/* Move it under Utils */
const courierAccentColors = [
  '#660066',
  '#205A6D',
  '#006600',
  '#B35900',
  '#AF48C0',
  '#2A3379',
  '#6600FF',
];

export const getCourierAccentColor = (courierId: string) => {
  return courierAccentColors[stringToNumberFrom0To9(courierId)];
};

export const getActiveOrdersList = () => {};


const reducer = (
  state: ICouriersState,
  action: { type: CouriersActionType; payload?: any }
): ICouriersState => {
  switch (action.type) {
    case CouriersActionType.SetCouriers: {
      const couriers : Array<ICourier> = action.payload
      const nonGuestCouriers : Array<ICourier> = couriers.filter((c : ICourier) => !c.isGuest)
      const orderedGuestCourierList : Array<ICourier> = couriers.filter((c: ICourier) => c.isGuest )
                                                                .sort((a : any,b : any)=> a.timestamp - b.timestamp)
                                                                .map((c : ICourier, index : number)=> {
                                                                      const queueNumber = index + 1
                                                                      c.guestQueueNumber = queueNumber
                                                                      c.firstName = `${queueNumber}@courier.courier_guest`
                                                                      return c
                                                                    }) 
      const couriersList = [...nonGuestCouriers, ...orderedGuestCourierList]

      const courierListSnapshotItems = couriersList.reduce(
        (courierListSnapshot: any, { ...courier }: ICourier) => {
          courierListSnapshot[courier.id] = courier;
          courierListSnapshot[courier.id].accentColor = getCourierAccentColor(
            courier.id
          );

          return courierListSnapshot;
        },
        {}
      );

      return {
        ...state,
        couriersList,
        couriersById: {
          ...courierListSnapshotItems,
        },
      };
    }

    case CouriersActionType.AddCourier:
      
      const courier : ICourier = action.payload

      if (courier.lastName === 'Guest') {
        const currentGuestCount = state.couriersList.filter((c : ICourier)=> c.isGuest).length
        const queueNumber = currentGuestCount + 1
        courier.isGuest = true
        courier.guestQueueNumber = queueNumber
        courier.firstName = `${queueNumber}@courier.courier_guest`
      }

      return state.couriersById[action.payload.id]
        ? state
        : {
            ...state,
            couriersById: {
              ...state.couriersById,
              [action.payload.id]: {
                ...courier,
                accentColor: getCourierAccentColor(courier.id),
                isGuest: action.payload.lastName === 'Guest'
              },
            },
            couriersList: [...state.couriersList, courier]
          };

    case CouriersActionType.UpdateCourier: {
      const currentCourier = state.couriersById[action.payload.id];
      
      /* TODO: this field cause a BUG */
      /*       if (
        !currentCourier ||
        Number(currentCourier.timestamp) > action.payload.timestamp
      ) {
        console.log('On not Currents', currentCourier);
        return state;
      } */
      if (!currentCourier) {
        return state;
      }

      return {
        ...state,
        couriersById: {
          ...state.couriersById,
          [action.payload.id]: {
            ...currentCourier,
            ...action.payload,
            firstName: state.couriersById[action.payload.id].firstName,
            isGuest: state.couriersById[action.payload.id].isGuest,
          },
        },
      };
    }

    case CouriersActionType.UpdateCourierLocation: {
      const currentCourier = state.couriersById[action.payload.id];

      if (
        !currentCourier ||
        Number(currentCourier.lastLocationUpdated) > action.payload.timestamp
      ) {
        return state;
      }

      const updatedCouier = {
        ...currentCourier,
        lastLocationUpdated: action.payload.timestamp,
        location: action.payload.location,
      };

      return {
        ...state,
        couriersById: {
          ...state.couriersById,
          [action.payload.id]: updatedCouier,
        },
      };
    }

    case CouriersActionType.UpdateCourierRoute: {
      const currentCourier = state.couriersById[action.payload.courier.id];

      if (
        !currentCourier /* ||
        Number(currentCourier.lastPoolUpdated) > action.payload.timestamp */
      ) {
        return state;
      }

      const route = action.payload;
      const getNextOrderReference = route.waypoints
        .filter((waypoint: IWaypoint) => waypoint.isDelivered === false)
        .map((data: IWaypoint) => data.order.reference)[0];
      const orderBeingDelivered =
        route && route.waypoints.length
          ? route.waypoints.filter(
              (waypoint: IWaypoint) => waypoint.isDelivered == true
            ).length
          : 0;

      const updatedCouier = {
        ...currentCourier,
        lastPoolUpdated: route.timestamp,
        orderPool: {
          nextOrderReference: getNextOrderReference || null,
          orderBeingDelivered,
          totalOrders: route.waypoints.length,
          route,
        },
      };

      return {
        ...state,
        couriersById: {
          ...state.couriersById,
          [action.payload.courier.id]: updatedCouier,
        },
      };
    }

    case CouriersActionType.SetSelectedCourierId:
      return {
        ...state,
        selectedCourierId: action.payload,
      };

    case CouriersActionType.SetCourierRoutes: {
      action.payload.routes.map((route: IRoute) => {
        const getOrderBeingDelivered = route.waypoints.filter(
          (waypoint: IWaypoint) => waypoint.isDelivered === true
        ).length;
        action.payload.activeOrders.map((items: string) => {
          if (
            route.waypoints
              .map((waypointData) => waypointData.order.uuid)
              .includes(items)
          ) {
            if (state.couriersById[route.courier.id] !== undefined) {
              const getNextOrderReference = route.waypoints
                .filter((waypoint: IWaypoint) => waypoint.isDelivered === false)
                .map((res) => res.order.reference)[0];

              state.couriersById[route.courier.id] = {
                ...state.couriersById[route.courier.id],
                orderPool: {
                  nextOrderReference: getNextOrderReference || null,
                  route: { ...route },
                  totalOrders: route.waypoints.length,
                  orderBeingDelivered: getOrderBeingDelivered,
                },
              };
            }
          }
        });

        if (state.couriersById[route.courier.id]?.isGuest) {
          if (state.couriersById[route.courier.id]?.orderPool) {
            //Will remove
          } else {
            delete state.couriersById[route.courier.id];
          }
        }
      });

      return {
        ...state,
      };
    }

    case CouriersActionType.SetCourierStatus: {
      //const now = dayjs(new Date()).valueOf(); 
      action.payload.map((status: ICourierReturnStatus) => {
        if (state.couriersById[status.id]) {

          state.couriersById[status.id] = {
            ...state.couriersById[status.id],
            returnBack: {
              ...status
            },
          };
        }
      });

      return {
        ...state,
      };
    }

    case CouriersActionType.UpdateCourierStatus: {
      
      if (state.couriersById[action.payload.id]) {
        
        state.couriersById[action.payload.id] = {
          ...state.couriersById[action.payload.id],
          returnBack: {
            ...action.payload,
          },
        };
      }
      return {
        ...state,
      };
    }

    case CouriersActionType.SetEtaLists: {
      action.payload.filter((eta: IEta) => state.couriersById[eta.id]?.returnBack?.status === CourierReturnStatusType.Returning ).map((eta: IEta) => {    

        if (state.couriersById[eta.id]) {
          state.couriersById[eta.id] = {
            ...state.couriersById[eta.id],
            backBy: {
              ...eta,
            },
          };
        }
      });

      return {
        ...state,
      };
    }

    case CouriersActionType.UpdateEta: {
      if (state.couriersById[action.payload.id]) {
        state.couriersById[action.payload.id] = {
          ...state.couriersById[action.payload.id],
          backBy: {
            ...action.payload,
          },
        };
      }
      return {
        ...state,
      };
    }

    case CouriersActionType.CourierDeleted: {
      if (state.couriersById[action.payload.id]) {
        delete state.couriersById[action.payload.id];
      }
      return {
        ...state,
        couriersList: [...state.couriersList.filter(courier => courier.id !== action.payload.id),]
      };
    }

    case CouriersActionType.NextRouteUpdate: {
      if(state.couriersById[action.payload.courier.id]) {
        state.couriersById[action.payload.courier.id] = {
          ...state.couriersById[action.payload.courier.id],
          nextOrderPool: {
            route: action.payload
          }
        }
      }
      return {
        ...state
      }
    }

    case CouriersActionType.SetNextRoute: {
      if(state.couriersById[action.payload.courier.id]) {
        state.couriersById[action.payload.courier.id] = {
          ...state.couriersById[action.payload.courier.id],
          nextOrderPool: {
            route: action.payload
          }
        }
      }
      return {
        ...state
      }
    }

    case CouriersActionType.SetCourierInDelivery: {
      console.log('Action Payload',action.payload);
      return {
        ...state
      }
    }

    default:
      return state;
  }
};

const [CouriersCtxProvider, useCouriersState, useCouriersDispatch] =
  generateContext(reducer, initialState);

const useCouriersActions = () => {
  const dispatch = useCouriersDispatch();

  const setCouriers = (couriers: ICourier) => {
    const action = createAction(CouriersActionType.SetCouriers, couriers);
    dispatch(action);
  };

  const addCourier = (courier: ICourier) => {
    const action = createAction(CouriersActionType.AddCourier, courier);
    dispatch(action);
  };

  const updateCourier = (courier: ICourier) => {
    const action = createAction(CouriersActionType.UpdateCourier, courier);
    dispatch(action);
  };

  const setSelectedCourierId = (courierId: string | null) => {
    const action = createAction(
      CouriersActionType.SetSelectedCourierId,
      courierId
    );
    dispatch(action);
  };

  const updateCourierLocation = (courier: ICourier) => {
    const action = createAction(
      CouriersActionType.UpdateCourierLocation,
      courier
    );

    dispatch(action);
  };

  const updateCourierRoute = (courier: IRoute) => {
    const action = createAction(CouriersActionType.UpdateCourierRoute, courier);
    dispatch(action);
  };

  const setCourierStatus = (courierStatus: ICourierReturnStatus[]) => {
    const action = createAction(
      CouriersActionType.SetCourierStatus,
      courierStatus
    );
    dispatch(action);
  };

  const updateCourierStatus = (courierStatus: ICourierReturnStatus) => {
    const action = createAction(
      CouriersActionType.UpdateCourierStatus,
      courierStatus
    );
    dispatch(action);
  };

  const setCourierRoutes = (routes: IRoute[], activeOrders: any) => {
    const action = createAction(CouriersActionType.SetCourierRoutes, {
      routes,
      activeOrders,
    });
    dispatch(action);
  };

  const setEtaLists = (eta: IEta[]) => {
    const action = createAction(CouriersActionType.SetEtaLists, eta);
    dispatch(action);
  };

  const updateEta = (eta: IEta) => {
    const action = createAction(CouriersActionType.UpdateEta, eta);
    dispatch(action);
  };

  const deleteCourier = (deletedCourier: ICourierDeleted) => {
    const action = createAction(
      CouriersActionType.CourierDeleted,
      deletedCourier
    );
    dispatch(action);
  };

  const setNextRoute = (route: IRoute) => {
    const action = createAction(CouriersActionType.SetNextRoute,route);
    dispatch(action);

  };

  const updateNextRoute = (route: IRoute) => {
    const action = createAction(CouriersActionType.NextRouteUpdate,route);
    dispatch(action)
  }

  const setCourierInDelivery = (courierId: string, isInDelivery: boolean) => {
    const action = createAction(CouriersActionType.SetCourierInDelivery,{courierId,isInDelivery})
    dispatch(action);
  }

  return {
    addCourier,
    updateCourier,
    updateCourierLocation,
    updateCourierRoute,
    setSelectedCourierId,
    setCouriers,
    setCourierRoutes,
    setCourierStatus,
    updateCourierStatus,
    setEtaLists,
    updateEta,
    deleteCourier,
    setNextRoute,
    updateNextRoute,
    setCourierInDelivery
  };
};

export { CouriersCtxProvider, useCouriersState, useCouriersActions };
